const about = {
  path: '/about',
  title: 'About Me',
};

export default about;
